import { DescriptionList } from "@prequel/shared-components";

import Timestamp from "@/components/Timestamp";
import { useDestinationContext } from "@/pages/import/DestinationsPage/DestinationPage";
import { TYPE_LABELS } from "@/pages/import/DestinationsPage/DestinationsTable";

const DestinationDetails = () => {
  const { destination } = useDestinationContext();

  return (
    <>
      <div className="space-y-1">
        <h3 className="text-lg/6 font-medium text-gray-900">Details</h3>
      </div>
      <div className="mt-6">
        <DescriptionList>
          <DescriptionList.Item label="ID" value={destination.id} />
          <DescriptionList.Item label="Name" value={destination.name} />
          <DescriptionList.Item label="Type" value={TYPE_LABELS[destination.type] ?? destination.type} />

          {destination.webhook_record && (
            <>
              <DescriptionList.Item label="Method" value={destination.webhook_record.request_template.method} />
              <DescriptionList.Item label="URI" value={destination.webhook_record.request_template.uri} />
              <DescriptionList.Item label="Max Records/min" value={destination.webhook_record.max_records_per_minute} />
              <DescriptionList.Item label="Max Concurrency" value={destination.webhook_record.max_concurrency} />
            </>
          )}

          {destination.webhook_batch && (
            <>
              <DescriptionList.Item label="Method" value={destination.webhook_batch.request_template.method} />
              <DescriptionList.Item label="URI" value={destination.webhook_batch.request_template.uri} />
              <DescriptionList.Item label="Format" value={destination.webhook_batch.format} />
              <DescriptionList.Item label="Max Batch Size" value={destination.webhook_batch.max_size_per_batch} />
              <DescriptionList.Item label="Max Batches/min" value={destination.webhook_batch.max_batches_per_minute} />
              <DescriptionList.Item label="Max Concurrency" value={destination.webhook_batch.max_concurrency} />
            </>
          )}

          <DescriptionList.Item label="Created" value={<Timestamp timestamp={destination.created_at} />} />
          <DescriptionList.Item label="Updated" value={<Timestamp timestamp={destination.updated_at} />} />
        </DescriptionList>
      </div>
    </>
  );
};

export default DestinationDetails;
